import produce from 'immer'
import {
  WMR_CONFIG_LOAD,
  WMR_CONFIG_LOAD_SUCCESS,
  WMR_CONFIG_LOAD_FAIL,
  WMR_RULESET_UPLOAD,
  WMR_RULESET_UPLOAD_SUCCESS,
  WMR_RULESET_UPLOAD_FAIL,
  WMR_RULESET_UPLOAD_RESET,
  WMR_RULESET_CONFIRM,
  WMR_RULESET_CONFIRM_SUCCESS,
  WMR_RULESET_CONFIRM_FAIL,
  WMR_RULESET_EXPORT,
  WMR_RULESET_EXPORT_SUCCESS,
  WMR_RULESET_EXPORT_FAIL,
  WMR_RULESET_EXPORT_RESET,
  WmrConfigData,
  ValidationResult
} from './actions'

interface WmrConfigState {
  loading: boolean
  error: any
  data: WmrConfigData | null
  upload: {
    loading: boolean
    error: any
    rulesetId: string | null
    ruleCount: number
    isValid: boolean
    validationResults: ValidationResult[]
  }
  confirm: {
    loading: boolean
    error: any
  }
  export: {
    loading: boolean
    error: any
    exportFileSasUrl: string | null
  }
}

const initialState: WmrConfigState = {
  loading: false,
  error: null,
  data: null,
  upload: {
    loading: false,
    error: null,
    rulesetId: null,
    ruleCount: 0,
    isValid: false,
    validationResults: []
  },
  confirm: {
    loading: false,
    error: null
  },
  export: {
    loading: false,
    error: null,
    exportFileSasUrl: null
  }
}

export const reducer = (state = initialState, action: any) =>
  produce(state, draft => {
    switch (action.type) {
      case WMR_CONFIG_LOAD: {
        draft.loading = true
        draft.error = null
        return
      }
      case WMR_CONFIG_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.data = action.config
        return
      }
      case WMR_CONFIG_LOAD_FAIL: {
        draft.loading = false
        draft.error = action.error
        return
      }

      case WMR_RULESET_UPLOAD: {
        draft.upload.loading = true
        draft.upload.error = null
        draft.upload.rulesetId = null
        draft.upload.ruleCount = 0
        draft.upload.isValid = false
        draft.upload.validationResults = []
        return
      }
      case WMR_RULESET_UPLOAD_SUCCESS: {
        draft.upload.loading = false
        draft.upload.error = null
        draft.upload.rulesetId = action.response.rulesetId
        draft.upload.ruleCount = action.response.ruleCount
        draft.upload.isValid = action.response.isValid
        draft.upload.validationResults = action.response.validationResults
        return
      }
      case WMR_RULESET_UPLOAD_FAIL: {
        draft.upload.loading = false
        draft.upload.error = action.error
        return
      }

      case WMR_RULESET_UPLOAD_RESET: {
        draft.upload.loading = false
        draft.upload.error = null
        draft.upload.rulesetId = null
        draft.upload.ruleCount = 0
        draft.upload.isValid = false
        draft.upload.validationResults = []
        return
      }

      case WMR_RULESET_CONFIRM: {
        draft.confirm.loading = true
        draft.confirm.error = null
        return
      }
      case WMR_RULESET_CONFIRM_SUCCESS: {
        draft.confirm.loading = false
        draft.confirm.error = null
        // Clear the upload state after successful confirmation
        draft.upload.rulesetId = null
        draft.upload.ruleCount = 0
        draft.upload.isValid = false
        draft.upload.validationResults = []
        return
      }
      case WMR_RULESET_CONFIRM_FAIL: {
        draft.confirm.loading = false
        draft.confirm.error = action.error
        return
      }

      case WMR_RULESET_EXPORT: {
        draft.export.loading = true
        draft.export.error = null
        draft.export.exportFileSasUrl = null
        return
      }
      case WMR_RULESET_EXPORT_SUCCESS: {
        draft.export.loading = false
        draft.export.error = null
        draft.export.exportFileSasUrl = action.exportFileSasUrl
        return
      }
      case WMR_RULESET_EXPORT_FAIL: {
        draft.export.loading = false
        draft.export.error = action.error
        return
      }

      case WMR_RULESET_EXPORT_RESET: {
        draft.export.loading = false
        draft.export.error = null
        draft.export.exportFileSasUrl = null
        return
      }

      default:
        return
    }
  })
